<template>
  <j-modal
    :title="title"
    :width="800"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    :okText="this.$store.getters.language['common.okButton']"
    :ok-disabled="disableSubmit"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton']"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-model  ref="form" :model="model" >
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="itemValue"
          :rules="[{required:true,message:language['common.pleaseInput']+language['common.code']},{ validator: this.validateItemValue }]"
          :label="language['common.code']">
          <a-input :placeholder="language['common.pleaseInput']+language['common.code']"  :maxLength="100" v-model="model.itemValue" :disabled="disableSubmit"/>

        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="itemText"
          :rules="[{required:true,message:language['common.pleaseInput']+language['common.name']},{ validator: this.validateItemName }]"
          :label="language['common.name']">
          <a-input :placeholder="language['common.pleaseInput']+language['common.name']" :maxLength="100" v-model="model.itemText" :disabled="disableSubmit"/>
        </a-form-model-item>

        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['common.desc']" >
          <a-input v-model="model.description" :maxLength="250" :disabled="disableSubmit"/>
        </a-form-model-item>

        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="langKey"
          :label="language['Multilingual.columns.key']"
          :rules="[{required:false},{ validator: this.validateLangKey }]"
        >
          <a-input v-model="model.langKey"  :maxLength="1000" :disabled="disableSubmit"/>
        </a-form-model-item>

        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['common.sort']" >
          <a-input-number :min="1" v-model="model.sortOrder" :disabled="disableSubmit"/>
          {{language['common.sortvalue']}}
        </a-form-model-item>

        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['column.status']"
          hasFeedback>
          <a-switch :checkedChildren="language['downBoxValue.normal']" :unCheckedChildren="language['common.disable']" @change="onChose" v-model="visibleCheck" :disabled="disableSubmit"/>
        </a-form-model-item>

      </a-form-model>
    </a-spin>
  </j-modal>
</template>

<script>
  import { get, pick } from 'lodash';
  import {addDictItem, editDictItem} from '@/api/api'
  import { getAction } from '@api/manage'

  export default {
    name: "DictItemModal",
    data() {
      return {
        title: "操作",
        visible: false,
        visibleCheck: true,
        model: {},
        dictId: "",
        status: 1,
        labelCol: {
          xs: {span: 24},
          sm: {span: 5},
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 16},
        },
        confirmLoading: false,
        disableSubmit: false
      }
    },
    created() {
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      add(dictId) {
        this.dictId = dictId;
        //初始化默认值
        this.edit({sortOrder:1,status:1});
      },
      edit(record) {
        if (record.id) {
          this.dictId = record.dictId;
        }
        this.status = record.status;
        this.visibleCheck = (record.status == 1) ? true : false;
        this.model = Object.assign({}, record);
        this.model.dictId = this.dictId;
        this.model.status = this.status;
        this.visible = true;
      },
      onChose(checked) {
        if (checked) {
          this.status = 1;
          this.visibleCheck = true;
        } else {
          this.status = 0;
          this.visibleCheck = false;
        }
      },
      // 确定
      handleOk() {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            this.model.itemText = (this.model.itemText || '').trim()
            this.model.itemValue = (this.model.itemValue || '').trim()
            this.model.description = (this.model.description || '').trim()
            this.model.langKey = (this.model.langKey || '').trim()
            this.model.status = this.status;
            let obj;
            if (!this.model.id) {
              obj = addDictItem(this.model);
            } else {
              obj = editDictItem(this.model);
            }
            obj.then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }else{
            return false;
          }
        })
      },
      // 关闭
      handleCancel() {
        this.close();
      },
      close() {
        this.$emit('close');
        this.visible = false;
        this.disableSubmit = false;
        this.$refs.form.resetFields();
      },
      validateItemValue(rule, value, callback){
        let param = {
          itemValue:value,
          dictId:this.dictId,
        }
        if(this.model.id){
          param.id = this.model.id
        }
        if(value){
          let reg=new RegExp("[`~!@#$^&*()=|{}'.<>《》?！￥（）—【】‘；：”“。，、？]")
          if(reg.test(value)){
            callback(this.language["common.codenotchart"])
          }else{
            //update--begin--autor:lvdandan-----date:20201203------for：JT-27【数据字典】字典 - 编码可重复
            getAction("/sys/dictItem/dictItemCheck",param).then((res)=>{
              if(res.success){
                callback()
              }else{
                callback(res.message);
              }
            });
            //update--end--autor:lvdandan-----date:20201203------for：JT-27【数据字典】字典 - 编码可重复
          }
        }else{
          callback()
        }
      },
      validateItemName(rule, value, callback){
        let param = {
          itemValue:value,
          dictId:this.dictId,
        }
        if(this.model.id){
          param.id = this.model.id
        }
        if(value)
        {
          getAction("/sys/dictItem/doDictNameCheck",param).then((res)=>{
              if(res.success){
                callback()
              }else{
                callback(res.message);
              }
            });
        }else{
          callback()
        }
      },
      validateLangKey(rule, value, callback){

        if(value)
        {
          getAction("/sys/tSysLanguage/checkHasKey",{langKey:value}).then((res)=>{
            if(res){
              callback()
            }else{
              callback("key "+this.language['epi.absent']+"！");
            }
          });
        }else{
          callback()
        }
      }

    }
  }
</script>
